<template lang="pug">
layout(:contents="contents", @close="close", :prevRoute="prevRoute")
</template>

<script>
import layout from "./layouts"
export default {
  name: "cms",
  components: { layout },
  data() {
    return {
      contents: [],
      prevRoute: null
    }
  },
  async activated() {
    const { target, category } = this.$route.params
    const pool = this.$store.state.data[target]
    if (!pool || !Array.isArray(pool)) return this.close()

    this.contents = pool.filter(rec => (category ? rec.id == category : true)) || []

    if (!this.contents || !this.contents.length) return this.close()
  },
  methods: {
    close() {
      __.platform.go()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevRoute = from.path))
  }
}
</script>
